import React from 'react';
import { Row, Col, FormGroup, Label, Input } from 'reactstrap';

const LoadingScreenFilters = ({ searchTerm, setSearchTerm, statusFilter, setStatusFilter }) => {
  return (
    <Row className="mt-4">
      <Col md="6">
        <FormGroup>
          <Label>Tìm kiếm</Label>
          <Input 
            type="text" 
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="border-0 shadow-sm"
            placeholder="Tìm theo filename..."
          />
        </FormGroup>
      </Col>
      <Col md="6">
        <FormGroup>
          <Label>Lọc theo trạng thái</Label>
          <Input 
            type="select"
            value={statusFilter}
            onChange={(e) => setStatusFilter(e.target.value)}
            className="border-0 shadow-sm"
          >
            <option value="all">Tất cả</option>
            <option value="active">Đang hoạt động</option>
            <option value="inactive">Không hoạt động</option>
          </Input>
        </FormGroup>
      </Col>
    </Row>
  );
};

export default LoadingScreenFilters;

